<template>
  <enter-otp
  :onValidOTP="validOTP"
  :onRequiredFieldMissing="missingRequiredField" />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Segment from '@/Segment';
import EnterOtp from '@/components/EnterOtp.vue';
import { SIGNUP_FIRST_PAGE } from '@/router/consts';
import GeneralErrorHandling from '@/mixins/GeneralErrorHandling';
import Affiliates from '@/mixins/Affiliates';

export default {
  name: 'SignupEnterOtp',
  mixins: [GeneralErrorHandling, Affiliates],
  components: { EnterOtp },
  computed: {
    ...mapGetters('signup', ['SignupErrorTypes']),
  },
  methods: {
    ...mapActions('signup', ['signup']),
    async validOTP() {
      try {
        const status = await this.signup();
        if (status === this.SignupErrorTypes.OK) {
          Segment.trackUserInteraction('Saving_FESignupCompleted', { affiliate: this.affiliateId });
          await this.$router.push({ path: '/meitav/open-fund' });
        } else if (status === this.SignupErrorTypes.SAVER_ALREADY_EXISTS) {
          Segment.trackUserInteraction('Saving_FESignupExistingMember');
          await this.$router.push({ path: '/meitav/welcome-back' });
        } else {
          throw Error('Unexpected result from server');
        }
      } catch (err) {
        this.logErrorAndShowDialog(err);
      }
    },
    missingRequiredField() {
      this.$router.push(SIGNUP_FIRST_PAGE);
    },
  },
};
</script>
